import getParameter from './getParameter';
function UTM() {
    this.parameters = [
        'source',
        'medium',
        'campaign',
        'term',
        'content',
    ];
}

UTM.prototype.storeData = function() {
    const utm = {};
    let one_utm_param_found = false;
    let key;
    let value;
    
    for (let i = 0; i < this.parameters.length; i++) {
        key = this.parameters[i];
        value = getParameter('utm_' + key);
        if (value) {
            utm[key] = value;
            one_utm_param_found = true;
        }
    }

    if (one_utm_param_found) {
        localStorage.setItem('gp_utm', JSON.stringify(utm));
    }
}

UTM.prototype.getData = function() {
    let utm = localStorage.getItem('gp_utm');
    if (utm) {
        return JSON.parse(utm);
    }
    return false;
}

export default UTM;



// WEBPACK FOOTER //
// ./js/util/utm-tracking.js